import { relations } from 'drizzle-orm'
import { pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getNullableIdReference,
  typedJsonb,
} from '../common/utils'
import { users } from './user'

export const callingCampaigns = pgTable(
  'calling_campaigns',
  {
    ...getBaseFields(),
    name: text().notNull(),
    description: text(),
    audienceFilter: typedJsonb('audience_filter').notNull(),
    createdById: getNullableIdReference(() => users.id),
    // NULL or empty/whitespace = no pre-call SMS for this campaign — the
    // template doubles as the on/off signal.
    preCallSmsTemplate: text(),
  },
  (table) => getBaseIndexes('calling_campaigns', table),
)

export const callingCampaignsRelations = relations(
  callingCampaigns,
  ({ one }) => ({
    createdBy: one(users, {
      fields: [callingCampaigns.createdById],
      references: [users.id],
    }),
  }),
)
